import React from 'react';

import { SpinnerOverlay, SubmissionButtons } from '@components/common';

import { useManageSites } from '@hooks/useManageSites';

import { isEmpty, isEqual } from '@utils/common';

import { ICoords, ISiteMarker } from '@interfaces/map/map';

import styles from '../LocationChangeView.module.scss';

interface ISiteLocationChangeViewProps {
	site: ISiteMarker;
	newCoords?: ICoords;
	reset: () => void;
}

const SiteLocationChangeView = ({
	site,
	newCoords,
	reset,
}: ISiteLocationChangeViewProps) => {
	const { editSiteHandler, isLoadingSites } = useManageSites({
		closeSiteModal: reset,
	});

	const initialCoords = {
		lat: site.lat,
		lng: site.lng,
	};

	const submit = () => {
		if (!newCoords) return;

		editSiteHandler({
			id: site.id,
			values: {
				lat: newCoords.lat,
				lng: newCoords.lng,
				siteId: site.siteId,
				siteType: site.siteType.title,
				vendor: site.vendor?.name,
			},
		});
	};

	return (
		<div>
			{isLoadingSites && <SpinnerOverlay />}
			<div className={styles.title}>{site.siteType.title}</div>
			<div className={styles.markerId}>
				<div>
					<span>Site ID:&nbsp;</span>
					{site.siteId}
				</div>
				<div>
					<span>Latitude:&nbsp;</span>
					{site.lat}
				</div>
				<div>
					<span>Longitude:&nbsp;</span>
					{site.lng}
				</div>
				<div>
					<span>Vendor:&nbsp;</span>
					{site.vendor?.title}
				</div>
			</div>
			<div className={styles.newLocation}>
				<div className={styles.title}>New location:</div>
				<div className={styles.coords}>
					<div>
						<span>Latitude:&nbsp;</span>
						{newCoords?.lat || site.lat}
					</div>
					<div>
						<span>Longitude:&nbsp;</span>
						{newCoords?.lng || site.lng}
					</div>
				</div>
			</div>
			<SubmissionButtons
				disabledPositive={isEmpty(newCoords) || isEqual(newCoords, initialCoords)}
				negativeHandler={reset}
				positiveHandler={submit}
				positiveLabel='Apply'
			/>
		</div>
	);
};

export default SiteLocationChangeView;
